import { useState } from "react";
import SectionHeading from "./SectionHeading";

const FAQS = [
  {
    q: "吾爱吃瓜是一个什么样的网站？",
    a: "吾爱吃瓜是一个汇聚全网网友评论与评论区热议的围观社区。你可以在这里浏览热门话题、围观网友的神回复、参与讨论，也可以在瓜田剧场里发弹幕，感受轻松快乐的吃瓜氛围。",
  },
  {
    q: "如何参与话题讨论或发布评论？",
    a: "直接浏览感兴趣的话题，点击进入即可参与讨论。我们鼓励理性、友善的发言，请尊重不同观点，避免使用侮辱性语言，共同维护文明的讨论环境。",
  },
  {
    q: "这里的弹幕功能如何使用？",
    a: "在瓜田剧场页面下方的输入框内输入你想说的话，点击「发送弹幕」即可让内容滚动划过屏幕。你也可以点击「快速说一句」里的短语一键发送，操作非常简单。",
  },
  {
    q: "内容是如何产生和更新的？",
    a: "话题与神评主要来源于网友们的自发分享和讨论。热议榜每十分钟刷新一次，实时反映大家最关注的内容，让每一次围观都跟得上最新节奏。",
  },
  {
    q: "遇到不友善或不当的言论该怎么办？",
    a: "请使用页面上的举报功能或通过下方「意见反馈」联系我们。我们设有内容审核机制，会及时处理违反社区守则的内容，为大家守住一个干净的吃瓜空间。",
  },
  {
    q: "我可以在其他平台分享这里的内容吗？",
    a: "可以的。分享时请注明来源，我们鼓励大家把有趣的话题和讨论带给更多朋友，让快乐的吃瓜氛围扩散到更远的地方。",
  },
];

export default function Faq() {
  const [open, setOpen] = useState<number>(0);

  const schema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: FAQS.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };

  return (
    <section id="faq" className="bg-background-100/70 py-16 md:py-20">
      <div className="mx-auto w-full max-w-4xl px-4 md:px-6">
        <SectionHeading
          eyebrow="常见问题"
          title="关于吃瓜，你可能想问"
          desc="这里汇总了瓜友们最常问的几个问题，如果还有疑问，欢迎通过下方反馈告诉我们。"
        />

        <div className="flex flex-col gap-3">
          {FAQS.map((item, idx) => {
            const isOpen = open === idx;
            return (
              <div
                key={item.q}
                className={`overflow-hidden rounded-2xl bg-background-50 ring-1 transition ${
                  isOpen ? "ring-primary-200" : "ring-background-200/70"
                }`}
              >
                <button
                  type="button"
                  aria-expanded={isOpen}
                  onClick={() => setOpen(isOpen ? -1 : idx)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <span className="text-[15px] font-medium text-foreground-900">{item.q}</span>
                  <span
                    className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition ${
                      isOpen ? "bg-primary-500 text-background-50 rotate-180" : "bg-secondary-100 text-secondary-800"
                    }`}
                  >
                    <i className="ri-arrow-down-s-line"></i>
                  </span>
                </button>
                {isOpen && (
                  <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600">{item.a}</p>
                )}
              </div>
            );
          })}
        </div>

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
        />
      </div>
    </section>
  );
}